module.exports = __webpack_public_path__ + "img/smartz-logo.1ff9f0b9.svg";